export enum TicketReviewerViewType {
  AllIssues = 'all issues',
  AssignedToMe = 'assigned to me',
}
